import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4fdf6bfc&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=4fdf6bfc&prod&lang=less&"
import style1 from "./Register.vue?vue&type=style&index=1&id=4fdf6bfc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdf6bfc",
  null
  
)

export default component.exports